module.exports = __webpack_public_path__ + "wj51c-tabletop.png?b4d2be48700ed58aa2d366379fd4e58b";